export default {
    header: 'สร้างวันทำงานพิเศษ',
    headerEdit: 'แก้ไขวันทำงานพิเศษ',
    specialWorkdayName: 'ชื่อวันทำงานพิเศษ',
    enterSpecialWorkdayName: 'กรุณากรอกวันทำงานพิเศษ',
    bureau: 'สำนักงาน',
    selectBureau: '- กรุณาเลือกสำนักงาน -',
    workDate: 'วันทำงาน',
    checkInTime: 'เริ่มลงเวลา',
    startTime: 'เริ่มทำงาน',
    lateCheckIn: 'ขาดครึ่งวัน',
    lastCheckIn: 'ขาดเต็มวัน',
    breakHours: 'ช่วงพัก',
    endTime: 'เลิกงาน',
    save: 'บันทึก',
    require: 'กรุณากรอกข้อมูล',
    requireBureau: 'กรุณาเลือกสำนักงาน',
    checkInTimeLessThanStartTime: 'เริ่มลงเวลา ต้องน้อยกว่า เริ่มทำงาน',
    startTimeLessThanLateCheckIn: 'เริ่มทำงาน ต้องน้อยกว่า ขาดครึ่งวัน',
    lateCheckInLessThanLastCheckIn: 'ขาดครึ่งวัน ต้องน้อยกว่า ขาดเต็มวัน',
    lastCheckInLessThanEndTime: 'ขาดเต็มวัน ต้องน้อยกว่า เลิกงาน',
    endTimeMoreThanLastCheckIn: 'เลิกงาน ต้องมากกว่า ขาดเต็มวัน',
    congratulation: 'ยินดีด้วย',
    created: 'วันทำงานพิเศษถูกสร้างแล้ว',
    updated: 'วันทำงานพิเศษถูกแก้ไขแล้ว',
    errorTitle: 'เกิดข้อผิดพลาด'
}
